module.exports = __webpack_public_path__ + "static/media/ball_3_6.6529abed.mp3";